<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppShell from '@/components/layout/AppShell.vue'
import { NotificationManager } from '@ui'

const route = useRoute()
// The login and callback screens carry their own chrome.
const useAuthLayout = computed(() => route.meta.layout === 'auth')
</script>

<template>
  <RouterView v-if="useAuthLayout" v-slot="{ Component }">
    <component :is="Component" />
  </RouterView>

  <AppShell v-else>
    <RouterView v-slot="{ Component }">
      <component :is="Component" />
    </RouterView>
  </AppShell>

  <NotificationManager />
</template>
